<template>

  <div class="Support">
    <h1>{{ $t('recovery.title') }}</h1>

    <el-form :model="supportForm" :rules="rulesSupport" ref="supportForm" class="" :show-message=false>

      <el-form-item prop="country">
        <el-select v-model="supportForm.country" @change="changeSelect" v-bind:placeholder="$t('recovery.stato')">
          <el-option v-for="item in countries" :key="item" :label="($t('recovery.stati')[item])" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="area">
        <el-select v-model="supportForm.area" @change="changeSelect" v-bind:placeholder="$t('recovery.area')">
          <el-option v-for="item in aree" :key="item" :label="($t('recovery.aree')[item])" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="contatto">
        <el-select v-model="supportForm.contatto" v-bind:placeholder="$t('recovery.contatto')">
          <el-option v-for="item in contatti" :key="item.nome" :label="item.nome" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="name">
        <el-input v-model="supportForm.name" v-bind:placeholder="$t('recovery.name')"></el-input>
      </el-form-item>
      <el-form-item prop="mail">
        <el-input v-model="supportForm.mail" v-bind:placeholder="$t('recovery.mail')"></el-input>
      </el-form-item>
      <el-form-item prop="subject">
        <el-input v-model="supportForm.subject" v-bind:placeholder="$t('recovery.subject')"></el-input>
      </el-form-item>
      <el-form-item prop="body">
        <el-input type="textarea" :rows="8" v-model="supportForm.body"
          v-bind:placeholder="$t('recovery.body')"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="submitForm()" class="btnSecretQuestion">{{ $t('recovery.btn.sendMail') }}
        </el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
export default {
  name: 'Support',
  props: ['language'],
  data() {
    return {
      supportForm: {
        area: '',
        country: '',
        contatto: '',
        name: '',
        email: '',
        subject: '',
        body: ''
      },
      rulesSupport: {
        contatto: [
          { required: true, trigger: 'blur' }
        ],
        name: [
          { required: true, trigger: 'blur' }
        ],
        mail: [
          { required: true, trigger: 'blur' }
        ],
        subject: [
          { required: true, trigger: 'blur' }
        ],
        body: [
          { required: true, trigger: 'blur' }
        ]
      },
      loginVisible: true,
      isErrorLogin: false,
      isErrorUsername: false,
      isErrorPwd: false,
      secretQuestions: {},
      countries: ['1', '2', '3', '4', '5'],
      aree: ['PORTAL', 'APK-ANDROID', 'APK-IOS'],
      contatti: []
    }
  },
  i18n: {
    messages: {
      it_IT: {
        recovery: {
          title: 'Supporto Tecnico',
          name: 'Nome e Cognome',
          mail: 'e-Mail',
          subject: 'Oggetto',
          body: 'Messaggio',
          btn: {
            sendMail: 'Invia'
          },
          msg: {
            1903: 'Request parameter error',
            1910: 'Errore nell\'invio della mail',
            sent: 'eMail inviata correttamente',
            1999: 'Errore di autenticazione al servizio'
          },
          stato: 'Stato',
          stati: {
            1: 'Italia',
            2: 'Francia',
            3: 'Spagna',
            4: 'Belgio',
            5: 'Germania'
          },
          area: 'Area di Lavoro',
          aree: {
            'PORTAL': 'LUCI Portal',
            'APK-ANDROID': 'LUCI APK Android',
            'APK-IOS': 'LUCI APK iOS'
          },
          contatto: 'Contatto'
        }
      },
      en_GB: {
        recovery: {
          title: 'Technical Support',
          name: 'Name Surname',
          mail: 'E-mail address',
          subject: 'Object',
          body: 'Message',
          btn: {
            sendMail: 'Submit'
          },
          msg: {
            1903: 'Request parameter error',
            1910: 'Errore nell\'invio della mail',
            sent: 'E-mail duly sent',
            1999: 'Errore di autenticazione al servizio'
          },
          stato: 'Country',
          stati: {
            1: 'Italy',
            2: 'France',
            3: 'Spain',
            4: 'Belgium',
            5: 'Germany'
          },
          area: 'Application Area',
          aree: {
            'PORTAL': 'LUCI Portal',
            'APK-ANDROID': 'LUCI APK Android',
            'APK-IOS': 'LUCI APK iOS'
          },
          contatto: 'Contact'
        }
      },
      es_ES: {
        recovery: {
          title: 'Soporte técnico',
          name: 'Nombre y apellidos',
          mail: 'Remitente de correo electrónico',
          subject: 'Objeto',
          body: 'Mensaje',
          btn: {
            sendMail: 'Enviar'
          },
          msg: {
            1903: 'Request parameter error',
            1910: 'Errore nell\'invio della mail',
            sent: 'Correo electrónico enviado con éxito',
            1999: 'Errore di autenticazione al servizio'
          },
          stato: 'País',
          stati: {
            1: 'Italia',
            2: 'Francia',
            3: 'España',
            4: 'Bélgica',
            5: 'Alemania'
          },
          area: 'Área de Aplicación',
          aree: {
            'PORTAL': 'LUCI Portal',
            'APK-ANDROID': 'LUCI APK Android',
            'APK-IOS': 'LUCI APK iOS'
          },
          contatto: 'Contacto'
        }
      },
      fr_FR: {
        recovery: {
          title: 'Assistance technique',
          name: 'Nom et prénom',
          mail: 'Email expéditeur',
          subject: 'Objet',
          body: 'Message',
          btn: {
            sendMail: 'Envoi'
          },
          msg: {
            1903: 'Request parameter error',
            1910: 'Errore nell\'invio della mail',
            sent: 'Enregistrement de l\'utilisateur effectué',
            1999: 'Errore di autenticazione al servizio'
          },
          stato: 'Nation',
          stati: {
            1: 'Italie',
            2: 'France',
            3: 'Espagne',
            4: 'Belgique',
            5: 'Allemagne'
          },
          area: 'Champ d\'Application',
          aree: {
            'PORTAL': 'LUCI Portal',
            'APK-ANDROID': 'LUCI APK Android',
            'APK-IOS': 'LUCI APK iOS'
          },
          contatto: 'Contact'
        }
      },
      de_DE: {
        recovery: {
          title: 'Technischer Service',
          name: 'Name Nachname',
          mail: 'Email Absender',
          subject: 'Betr',
          body: 'Meldung',
          btn: {
            sendMail: 'Senden'
          },
          msg: {
            1903: 'Request parameter error',
            1910: 'Errore nell\'invio della mail',
            sent: 'Benutzer korrekt registriert',
            1999: 'Errore di autenticazione al servizio'
          },
          stato: 'Land',
          stati: {
            1: 'Italien',
            2: 'Frankreich',
            3: 'Spanien',
            4: 'Belgien',
            5: 'Deutschland'
          },
          area: 'Anwendungsbereich',
          aree: {
            'PORTAL': 'LUCI Portal',
            'APK-ANDROID': 'LUCI APK Android',
            'APK-IOS': 'LUCI APK iOS'
          },
          contatto: 'Kontakt'
        }
      }
    }
  },
  beforeMount: function () {
    //this.getContatti()
  },
  methods: {
    submitForm: function () {
      console.log("submitForm")
      this.$refs['supportForm'].validate((valid) => {
        if (valid) {
          var obj = {
            country: this.supportForm.country,
            area: this.supportForm.area,
            contatto: this.supportForm.contatto.mail,
            name: this.supportForm.name,
            mail: this.supportForm.mail,
            subject: this.supportForm.subject,
            body: this.supportForm.body,
            codLang: this.$root.$i18n.locale.toLocaleString()
          }
          this.$http.post('noauth/support', obj).then(response => {
            if (response.body.rc === 0) {
              this.$message.success(this.$i18n.messages[this.$root.$i18n.locale.toLocaleString()].recovery.msg.sent)
              this.$router.push({ name: 'Login' })
            } else {
              var errCode = response.body.msg[0].msgId
              this.$message.error(this.$i18n.messages[this.$root.$i18n.locale.toLocaleString()].recovery.msg[errCode])
            }
          }, response => {
            this.isErrorLogin = true
          })
        } else {
          this.isErrorLogin = true
          return false
        }
      })
    },
    changeSelect: function () {
      this.$set(this.supportForm, 'contatto', '')
      this.$set(this, 'contatti', [])
      if (this.supportForm.area && this.supportForm.country) {
        this.getContatti()
      }
    },
    getContatti: function () {
      this.$http.get('noauth/contatti', {
        params: {
          codLang: this.$root.$i18n.locale.toLocaleString(),
          country: this.supportForm.country,
          area: this.supportForm.area
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            let data = response.body.data
            this.$set(this, 'contatti', data)
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].idWeb ? this.$t(response.body.msg[0].idWeb) : response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.Support {
  height: 630px;
  padding: 15px 50px;

  h1 {
    text-align: right;
    .set-font(@weight: 300, @size: 24px, @color: #fff);
    margin-bottom: 20px;
  }

  .el-form-item {
    text-align: center;
    margin-bottom: 0;

    .fa-icon {
      .set-font(@weight: 300, @size: 18px, @color: #fff);
    }

    &.is-error {
      .el-input__inner {
        outline: #f56c6c solid 1px;
        outline: rgba(255, 0, 0, 0.9) solid 1px;
        outline-offset: 0px;
      }
    }

    .el-input {
      width: 100%;

      .el-input__inner {
        .set-font(@weight: 300, @size: 14px, @color: #000);
        display: block;
        margin: 5px auto;
        padding: 10px;
        width: 300px;
        border: 0;
        background-color: #fff;
        //background-color: rgba(255, 255, 255, .7);
        border: none;
        border-radius: 0px;
        line-height: 0;
        height: 30px;

        &:focus {
          outline: #000 solid 1px;
          outline: rgba(0, 0, 0, .4) solid 1px;
          outline-offset: 0px;
        }
      }

      ::placeholder {
        .set-font(@weight: 300, @size: 14px, @color: #a2a2a2, @family: 'os-lightitalic');
      }
    }

    .el-textarea {
      width: 100%;

      .el-textarea__inner {
        .set-font(@weight: 300, @size: 14px, @color: #000);
        display: block;
        margin: 5px auto;
        padding: 10px;
        width: 300px;
        border: 0;
        background-color: #fff;
        //background-color: rgba(255, 255, 255, .7);
        border: none;
        border-radius: 0px;

        //line-height: 0;
        &:focus {
          outline: #000 solid 1px;
          outline: rgba(0, 0, 0, .4) solid 1px;
          outline-offset: 0px;
        }
      }

      ::placeholder {
        .set-font(@weight: 300, @size: 14px, @color: #a2a2a2, @family: 'os-lightitalic');
      }
    }

    &.recovery {
      padding-top: 30px;
    }

    .el-button {
      .set-font(@weight: 300, @size: 14px, @color: #fff);
      background-color: #000;
      background-color: rgba(0, 0, 0, .6);
      font-weight: 300;
      /*margin-top: 50px;*/
      /*margin-bottom: 45px;*/
      /*width:250px;*/
      transition: background-color .3s;
      border: 0;
      border-radius: 0;
      width: 300px;
      text-align: center;

      &:hover {
        background-color: #000;
        background-color: rgba(0, 0, 0, .8);
        cursor: pointer;
      }

      &:focus {
        outline: 0
      }

      &.btnSecretQuestion {
        margin: 5px auto;
        /*margin-top: 0px;*/
        /*margin-bottom: 10px;*/
      }

      &.btnRecovery {
        margin: 5px auto;
        /*margin-top: 0px;*/
        /*margin-bottom: 10px;*/
      }
    }
  }

  .errorLogin {
    .set-font(@weight: 300, @size: 14px, @color: #d20e0e);
    //display: block;
    height: 22px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/Support.vue